(function (window, document) {
    // set up Partially as a global object
    if (!window.Partially) {
        window.Partially = {};
    }

    window.Partially.MobileNavigation = function mobileNavigation(options) {

        let navigation = document.querySelector('.site-nav-main');
        let hamburger = document.querySelector('.hamburger');

        function initialize() {

            console.log();
            hamburger.addEventListener('click', function(){
                document.body.classList.toggle('sidebar-open');
                navigation.classList.toggle('is-active');
                hamburger.classList.toggle('is-active');

            })
        }

        initialize();
    }

})(window, document);
